<template>
  <v-card flat>        
    <v-icon class="close" @click="$emit('closeInstructors')">$sl-close</v-icon>
    <h2>{{$t('application.instructor.instructor.title')}}</h2>
    <p v-html="$t('application.instructor.instructor.modalText')"></p>
    <v-form>
      <v-text-field
        v-model="search"
        class="search-field mb-5"
        prepend-icon="$sl-search"
        single-line
        hide-details
        :label="$t('application.search-label')"
      />
    </v-form>
    <MessageBox
        v-if="!isAdministrator && hasDepartments($route.params.id)"
        class="my-5"
        type="info"
      >
        <p>{{ $t('company.department-instructor-info') +
        ' ' +
        getCurrentUserDepartments($route.params.id, isAdministrator, false) }}.</p>
    </MessageBox>
    <v-divider class="mt-6 mb-n3"></v-divider>
    <v-list class="instructorModal" flat>
        <v-radio-group v-model="selectedInstructorId" :multiple="false" >

          <template v-for="(inst, index) in searchedItems">
            <v-list-item :disabled="inst.disableItem" :class="inst.showMore ? 'three-line' : ''" :key="'instructor_'+ inst.id" class="mb-2" :value="inst.id" @click.stop="clickInstructor(inst)">             
              <v-list-item-action>
                <div class="v-list-item__radio">
                  <input type="radio" :mandatory="true" v-model="selectedInstructorId" :value="inst.id" />
                  <div class="check">
                    <div class="inside"></div>
                  </div>
                </div>
              </v-list-item-action>

              <v-list-item-content class="">
                <v-list-item-title v-html="inst.fullName"></v-list-item-title>
                <p class="pt-1 caption gray text-capitalize">{{ getInstructorProfessions(inst.instructor)}}</p>

                <template v-if="inst.showMore">
                  <v-list class="checklist" flat>
                    <v-list-item v-if="inst.email">
                      <v-list-item-icon>
                        <v-icon size="16px">$sl-check-circle</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>{{$t('application.instructor.instructor.email-check')}}</v-list-item-content>
                    </v-list-item>
                    <v-list-item v-else>
                      <v-list-item-icon>
                        <v-icon size="16px" class="color-red">$sl-warning</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content class="color-red"><b>{{$t('application.instructor.instructor.email-warning')}}</b></v-list-item-content>
                    </v-list-item>

                    <v-list-item v-if="inst.canHaveAnotherApprentice">
                      <v-list-item-icon >
                        <v-icon size="16px">$sl-check-circle</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>{{ $tc('labels.apprentice-count2', inst.numApprentices) }} {{ $t('application.instructor.instructor.appr-check', {
                          max: (profession.id === 848 ? 
                            `GU ${profession.maxApprenticesForInstructor}, Tot. 3` :
                            profession.maxApprenticesForInstructor
                          )
                        })}}</v-list-item-content>
                    </v-list-item>
                    <v-list-item v-else>
                      <v-list-item-icon>
                        <v-icon size="16px" class="color-red">$sl-warning</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content class="color-red"><b>{{ $tc('labels.apprentice-count', inst.numApprentices) }} {{ $t('application.instructor.instructor.appr-check', {
                        max: (profession.id === 848 ? 
                            `GU ${profession.maxApprenticesForInstructor}, Tot. 3` :
                            profession.maxApprenticesForInstructor
                          )
                        })}}</b></v-list-item-content>
                    </v-list-item>

                    <template>
                      <v-list-item v-if="haveCertificates(inst.instructor, selectedApplication.professionId,
                        selectedApplication.professionOrientations.map(ma => (ma.professionMachineOrientation && ma.professionMachineOrientation.machineId)), !selectedApplication.allCoursesApproved)">                      
                          <v-list-item-icon>
                            <v-icon size="16px">$sl-check-circle</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>{{$t('application.instructor.instructor.cert-check', { profession: getInstructorProfessions(inst.instructor, true) })}}</v-list-item-content>
                      </v-list-item>
                      <v-list-item v-else>
                        <v-list-item-icon>
                          <v-icon size="16px" class="color-red">$sl-warning</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content class="color-red"><b>{{$t('application.instructor.instructor.cert-check', {profession: getInstructorProfessions(inst.instructor, true, true)})}}</b></v-list-item-content>
                      </v-list-item>
                    </template>

                  </v-list>                  
                </template>               
              </v-list-item-content>               
            </v-list-item>
            <v-list-item :key="'message_' + index" v-if="inst.showMore==true">  
            <v-list-item-content class="pl-8">
              <p class="pt-2" v-if="Boolean(haveToReadInstruction(inst)) == true">{{$t('application.instructor.instructor.instruction-not-check')}}</p>
              <p class="pt-2" v-else>{{$t('application.instructor.instructor.instruction-check')}}</p>
              <div class="warning-message" v-if="!inst.canHaveAnotherApprentice">
                <p class="warning-message__title">{{$t('application.instructor.instructor.warning-title-max')}}</p>
                <p class="warning-message__text" v-html="$t('application.instructor.instructor.warning-text1')"></p>
              </div>
              <div class="warning-message" v-if="haveCertificates(inst.instructor, selectedApplication.professionId,
                  selectedApplication.professionOrientations.map(ma => ma.professionMachineOrientation.machineId), !selectedApplication.allCoursesApproved)==false">
                <p class="warning-message__title">{{$t('application.instructor.instructor.warning-title-tc')}}</p>
                <p class="warning-message__text" v-html="$t('application.instructor.instructor.warning-text2')"></p>
              </div>      
              <div class="warning-message" v-if="!inst.email">
                <p class="warning-message__title">{{$t('application.instructor.instructor.warning-title-email')}}</p>
                <p class="warning-message__text" v-html="$t('application.instructor.instructor.warning-text1-email')"></p>
              </div>      

          </v-list-item-content>    
          </v-list-item>   
            <template v-if="inst.showMore==false">
              <a class="text ml-8" :key="'alink_' + index" v-if="inst.disableItem" @click.stop="inst.showMore=true" href='#'>{{$t('application.instructor.instructor.show-more-missing')}}</a>
              <a class="text ml-8" :key="'alink2_' + index" @click.stop="inst.showMore=true" v-else href='#'>{{$t('application.instructor.instructor.show-more')}}</a>
            </template>                        
            <v-divider v-if="index!=(searchedItems.length-1)" class="mt-4 mb-2" :key="index"></v-divider>
          </template>
        </v-radio-group>
      </v-list>
    <ActionButton    
      class="mt-4"    
      :isDisabled="(selectedInstructorId && selectedInstructorId>0) ? false : true"
      actionIcon="$sl-save"
      @click="$emit('closeInstructors', selectedInstructorId)"
    >{{ $t('labels.save') }}</ActionButton>

      <ActionButton   
        class="mt-6 mb-4"         
        type="application"
        actionIcon="$sl-cancel"
        @click="$emit('closeInstructors')"
      >{{ $t('labels.cancel') }}</ActionButton>      
    
  </v-card>
</template>

<script>
import API from '@/services/api.js'
import {mapActions, mapGetters} from 'vuex'
import filter from 'lodash/filter'
import ActionButton from '@/components/Common/ActionButton'
import MessageBox from "@/components/Common/MessageBox.vue";
import {InstructorAbilities} from '@/components/mixins'
import { CompanyRoles } from "@/components/mixins";
const SugarDate = require('sugar/date')
// @group Company
// AdminApplicationModal component
export default {
  name: 'AdminApplicationModal',

  mixins: [InstructorAbilities, CompanyRoles],

  props: {    
    instructors: {      
      type: Array,      
      default: []
    },
    // application object
    instructorId: {
      // `Object`
      type: Number,
      default: -1
    },            
  },

  data: () => ({
    selectedInstructorId: -1,
    search: '',
    profession: {},
    commitedDate: ''
  }),

  computed: {
    ...mapGetters('application', ['selectedApplication']),
    ...mapGetters('basic', ['getProfessionNameById', 'basicProfessions', 'getProfessionById']),
    ...mapGetters('currentuser', ['currentUser', 'isAdministrator', 'isDepartmentAdministrator', 'isCompanyEducationResponsible']),
    searchedItems() {
      var result = []        

      if (this.search === '') { 
        result = this.instructors
      } else {
        let normalizedSearch = this.search.toLowerCase()
        result = this.instructors.filter(x => x.fullName.toLowerCase().includes(normalizedSearch))
      } 
      // If GU the instructor has to has the instructor role
      // if(this.selectedApplication.allCoursesApproved==false){

      //   if(this.hasDepartments(this.$route.params.id)) {
      //     result=result.filter(r => (r.instructor.isInstructor==true))
      //   }
      //   else {
      //     result=result.filter(r => (r.instructor.isInstructor==true))
      //   }
      // }
      // if(this.selectedApplication.allCoursesApproved==false || (this.selectedApplication.professionOrientations && this.selectedApplication.professionOrientations.length>0))
      // {
      //   result=result.filter(r => (r.tradeCertificates.length > 0 || r.instructorExemptions > 0 || r.machineQualifications > 0))        
      // }
      return result
    }
  },

  watch: {
    /**
     * @vuese
     * Used to open modal
     */
    instructors() {
      this.init()
    }
  },

  created() {
    this.init()
    this.getInstructions()
  },

  methods: {
    ...mapActions('application', ['setSelectedApplication', 'updateSelectedApplication']),
    /**
     * @vuese
     * Used to fetch the application based on applciation id and set it to the store
     * @arg The argument is integer values representing application id
     */
    init() {       
      this.selectedInstructorId=this.instructorId

      if(this.selectedApplication && this.selectedApplication.professionId)
        this.profession=this.getProfessionById(this.selectedApplication.professionId)
    },
    haveToReadInstruction(inst) {      
      const lastReadInstructions = inst.readInstructionsOn
      if (lastReadInstructions) {        
        return new SugarDate.Date(this.commitedDate).isAfter(lastReadInstructions).raw
      }  
      else {
        return true
      }
    },
    getInstructions(){      
      API.getInstructions()
        .then(({data}) => {
          this.commitedDate = data.committedAt                       
        })
        .catch(error => {
          console.log('Error', error)
        })              
    },
    getInstructorProfessions(instructor, withParentheses=false, showMissing=false){      

      let ret = ''
      let professionCerts = []
      if(instructor.employed && instructor.employed.tradeCertificates && instructor.employed.tradeCertificates.length>0) {
        instructor.employed.tradeCertificates.forEach(tr => {
        if(tr.approvedById && tr.approvedById>0 && tr.profession && tr.profession.name)
        {
          let machines=[]
          let text=''
          if(instructor.employed && instructor.employed.machinequalifications && instructor.employed.machinequalifications.length>0)
            machines = instructor.employed.machinequalifications.filter(ma=> ma.tradeCertificateId==tr.id)

          if(machines.length>0)
          {
            text=tr.profession.name + '/' + machines.map(m => m.machine.name).join(", ") 
            professionCerts.push(text.toLowerCase())
          }
          else {
            professionCerts.push(tr.profession.name.toLowerCase())
          }
        }
        });
      }
      if(instructor.employed && instructor.employed.instructorExemptions && instructor.employed.instructorExemptions.length>0) {
        instructor.employed.instructorExemptions.forEach(e => {
          if(e.approvedById && e.approvedById>0 && e.profession && e.profession.name)
          {
            professionCerts.push(e.profession.name.toLowerCase())
          }
        });
      }      
      if(withParentheses && professionCerts.length>0)
        ret='(' + professionCerts.join(", ") + ')'
      else 
        ret= professionCerts.join(", ")

      if (showMissing==true && ret=='')
        ret = this.$t('company.review.application.missing')
      return ret
    },
    clickInstructor(item) {
      this.selectedInstructorId=item.id      
    },    
  },
  components: {
    ActionButton,
    MessageBox
  }
}
</script>

<style lang="scss">
</style>